import { render, staticRenderFns } from "./tx-subject-preference.vue?vue&type=template&id=10edc172&scoped=true&"
import script from "./tx-subject-preference.ts?vue&type=script&lang=ts&"
export * from "./tx-subject-preference.ts?vue&type=script&lang=ts&"
import style0 from "./tx-subject-preference.scss?vue&type=style&index=0&id=10edc172&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10edc172",
  null
  
)

export default component.exports